/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {CatalogItemId, ServiceFunctionAssignmentInput, ServiceFunctionId} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddServiceFunctionUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/services/${id}/functions`;
};

/**
 * @summary Add service function
 */
export const addServiceFunction = async (
  id: CatalogItemId,
  serviceFunctionAssignmentInput: ServiceFunctionAssignmentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ServiceFunctionId> => {
  return customFetch<ServiceFunctionId>(getAddServiceFunctionUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(serviceFunctionAssignmentInput),
  });
};

export const getRemoveServiceFunctionUrl = (id: CatalogItemId, functionId: ServiceFunctionId) => {
  return `/api/v1/engineering/services/${id}/functions/${functionId}`;
};

/**
 * @summary Remove service function
 */
export const removeServiceFunction = async (
  id: CatalogItemId,
  functionId: ServiceFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveServiceFunctionUrl(id, functionId), {
    ...options,
    method: "DELETE",
  });
};
